import LogNames from 'txp-data/lib/schema/telemetry/LogNames';
import TxpEntitiesState from 'txp-data/lib/schema/innerSchema/TxpEntitiesState';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';
import { TxpDatapoint } from 'txp-data';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import { editableFlagCustomData } from '../../helpers/EditableCardConsts';
import shouldShowEditButton from '../../utils/view/shouldShowEditButton';

/**
 * populate the feedback dataPoint object
 */

export default function populateFeedbackDataPoint(
    feedbackType: string,
    entityNamesMap: number,
    origin: string,
    txpStatus: TxpStatus,
    txpConfiguration: TxpConfiguration
) {
    let state = null;
    let isEmailDonationRequested = null;
    const editableCustomData: TxpDatapoint =
        shouldShowEditButton(txpConfiguration, null /* cardItem */, entityNamesMap) &&
        editableFlagCustomData;
    if (txpStatus) {
        state = txpStatus.state;
        isEmailDonationRequested = txpStatus.isEmailDonationRequested;
    }
    return {
        ...editableCustomData,
        [LogNames.entityNamesMap]: entityNamesMap.toString(),
        [LogNames.feedbackActionType]: feedbackType,
        [LogNames.origin]: origin,
        [LogNames.tailoredEntityState]:
            state !== null && state !== undefined ? TxpEntitiesState[state] : null,
        [LogNames.teeEmailDonationRequested]:
            typeof isEmailDonationRequested == typeof true
                ? isEmailDonationRequested.toString()
                : null,
    };
}
